module.exports = __webpack_public_path__ + "nc_static/media/remote control.34f1b057.svg";